// extracted by mini-css-extract-plugin
export default {"wrapper":"TB-z","button":"UB-z","alternate":"VB-z","disabled":"WB-z","paymentWarning":"XB-z","fadeIn":"YB-z"};